import {Component} from '@angular/core';
import {NavController ,ToastController} from 'ionic-angular';


import {ItemsPage} from "../items/items";
import {ItemPage} from "../item-details/item-details";
import {SearchPage} from "../search/search";
import {CartPage} from "../cart/cart";
import {SearchCustomersPage} from "../search-customers/search-customers";
import {CART , CATEGORIESnTAGS, Theming, STOCKCART} from "../../providers/data";
import {Api} from "../../providers/api";
import { SpinnerDialog } from 'ionic-native';
import { Storage } from '@ionic/storage';
import { GVLogger } from '../../services/gv-logger';
import { MsgManager } from '../../providers/msg-manager';
import {LoginPage} from '../login/login';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  isOfflineMode = false;

  public cart: any;
  public catalogs:any = [];
  public tags:any = [];
  // list categories
  public categories: any;
  notFoundImage = "http://cdn01.anydatapoint.com/orders-app/modus-44b44c26-cae2-4da5-bacb-226b3af7eec0/products/default/dummy.png";
  // list of items
  public items: any;
  public theming = Theming;

  public tagsDisplayOnScreen = false;
  public catlogsDisplayOnScreen = false;
  stockCart: any;

  constructor(public nav: NavController,
  public api:Api,
  public storage:Storage,
  private gVLogger:GVLogger,
  private msgManager:MsgManager) {
    //this.categories = categoryService.getAll();

    this.storage.get("isOfflineMode").then((off)=>{
        this.isOfflineMode = off;

        if(this.isOfflineMode){
          this.goToSearchCustomersAll();
        }else{
          this.cart = CART;
          this.stockCart = STOCKCART;
          this.gVLogger.log("cart ===> ");
          this.gVLogger.log(this.cart)

          this.storage.get("user").then((user)=>{
            this.gVLogger.log("user Home: ");
            this.gVLogger.log(user);
          });


          SpinnerDialog.show("Loading...");
          this.getAllCatalogs();

        }

      });

  }

  // view a category
  viewCategory() {
    this.nav.push(ItemsPage);
  }

  // view a item
  viewItem(itemId) {
    this.nav.push(ItemPage, {id: itemId})
  }

  // go to search page
  goToSearch() {
    if(this.cart.customer!=null){
      this.nav.push(SearchPage);
    }else{
    this.nav.push(SearchCustomersPage);
    }

  }

  // view cart
  goToCart() {
    if(this.cart.customer!=null){
      this.nav.push(CartPage);
    }else{
    this.nav.push(SearchCustomersPage);
    }

  }

  goToSearchCustomersTag(tag){

    let tags = [];
    tags.push(tag.id);
    CATEGORIESnTAGS.tags = tags;
    CATEGORIESnTAGS.categories = [0];
    this.gVLogger.log(CATEGORIESnTAGS.tags);

    this.nav.push(SearchCustomersPage);
  }

  goToSearchCustomers(catalog){
    this.gVLogger.log(catalog);
    let tags = [];
    for (let tag of catalog.tagsDTOList) {
        tags.push(tag.id);
    }
    if(tags.length < 1){
      tags = [0];
    }
    CATEGORIESnTAGS.tags = tags;
    CATEGORIESnTAGS.categories = [0];
    this.gVLogger.log(CATEGORIESnTAGS.tags);

    this.nav.push(SearchCustomersPage);
  }


  goToSearchCustomersAll(){

    let tags = [];

     tags = [0];

    CATEGORIESnTAGS.tags = tags;
    CATEGORIESnTAGS.categories = [0];
    this.gVLogger.log(CATEGORIESnTAGS.tags);

    this.nav.setRoot(SearchCustomersPage);
  }



  goToCat(){
    this.nav.push(ItemsPage);
  }

  getAllCatalogs(){
    this.api.get("catalog/all").map(res => res.json()).subscribe(result=>{

      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else{
        this.catalogs = result.data;

        if(!(typeof this.catalogs === 'undefined') && this.catalogs){
          if(this.catalogs.length == 0){
            this.catlogsDisplayOnScreen = false;
          }else{
             this.catlogsDisplayOnScreen = true;
          }
        }else{
          this.catalogs = [];
        }


        this.gVLogger.log("Catalogs:");
        this.gVLogger.log(this.catalogs);
        this.getAllTags();
      }

    },
    err => { this.getAllTags(); });

  }

getAllTags(){
    this.api.get("tags/all").map(res => res.json()).subscribe(result=>{

      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        SpinnerDialog.hide();
        this.nav.setRoot(LoginPage);
      }else{
        this.tags = result.data;
        if (!(typeof this.catalogs === 'undefined') && this.catalogs) {
          if (this.tags.length == 0) {
            this.tagsDisplayOnScreen = false;
          } else {
            this.tagsDisplayOnScreen = true;
          }
        }else{
          this.tags = [];
        }
        this.gVLogger.log("Tags:");
        this.gVLogger.log(this.tags);
        this.checkCatAndTags();
        SpinnerDialog.hide();
      }
    }, err=>{
      this.checkCatAndTags();
    });
  }

  imageNotFound(e,catalog){
   catalog.imageUrl = this.notFoundImage;
  }


  checkCatAndTags(){
    this.gVLogger.log("tags check : ");
    this.gVLogger.log(this.tags);
    this.gVLogger.log("catalogs check : ");
    this.gVLogger.log(this.catalogs);
    this.gVLogger.log("checking tags and cats");


  if (!(typeof this.catalogs === 'undefined') || !(typeof this.tags === 'undefined') ) {
    this.gVLogger.log("catalogs Undefiend");
     if(this.tags && this.tags.length == 0 && this.catalogs && this.catalogs.length == 0){
      this.gVLogger.log("no tags catlogs found");
      this.nav.setRoot(SearchCustomersPage);
     }
  }else{
    this.gVLogger.log("Either of one is undefiened Tags,Catalogs");
    this.nav.setRoot(SearchCustomersPage);
  }


  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts